module.exports = __webpack_public_path__ + "img/banner-familyjpg.d103b974.jpg";